define([], function()
{
    return {
        rect: {
            kind: 'rect',
            attr: {
                width: 384,
                height: 256
            }
        },
        rectRound: {
            kind: 'rect',
            attr: {
                width: 384,
                height: 256,
                rx: 40,
                ry: 40
            }
        },
        square: {
            kind: 'rect',
            attr: {
                width: 256,
                height: 256
            }
        },
        squareL: {
            kind: 'rect',
            attr: {
                width: 512,
                height: 512
            }
        },
        squareM: {
            kind: 'rect',
            attr: {
                width: 192,
                height: 192
            }
        },
        parallelogram: {
            kind: 'path',
            attr: {
                width: 384,
                height: 256,
                d: 'M48,0 L0,256 L336,256 L384,0 Z'
            }
        },
        circle: {
            kind: 'circle',
            attr: {
                r: 128
            }
        },
        circleS: {
            kind: 'circle',
            attr: {
                r: 64
            }
        },
        circleM: {
            kind: 'circle',
            attr: {
                r: 96
            }
        },
        circleSFilled: {
            kind: 'circle',
            attr: {
                r: 64,
                className: 'node-shape-filled'
            }
        },
        ellipse: {
            kind: 'ellipse',
            attr: {
                rx: 192,
                ry: 128
            }
        },
        diamond: {
            kind: 'diamond',
            attr: {
                width: 384,
                height: 256
            }
        },
        human: {
            kind: 'human',
            attr: {
                width: 256
            }
        },
        barV: {
            kind: 'path',
            attr: {
                width: 64,
                height: 1536,
                d: 'M0,0 L32,0 L32,1536 L0,1536 Z'
            }
        },
        triangleDown: {
            kind: 'path',
            attr: {
                width: 128,
                height: 128,
                d: 'M0,0 L128,0 L64,128 Z'
            }
        },
        circleO: {
            kind: 'container',
            attr: {
                shapes: [
                    {
                        kind: 'circle',
                        attr: {
                            r: 64
                        }
                    },
                    {
                        kind: 'circle',
                        attr: {
                            className: 'node-shape-filled node-shape-nostroke',
                            r: 24
                        }
                    }
                ]
            }
        },
        circleX: {
            kind: 'container',
            attr: {
                shapes: [
                    {
                        kind: 'circle',
                        attr: {
                            r: 64
                        }
                    },
                    {
                        kind: 'path',
                        attr: {
                            className: 'node-shape-filled node-shape-nostroke',
                            width: 56,
                            height: 56,
                            d: 'M8,0 L56,48 L48,56 L0,8 Z'
                        }
                    },
                    {
                        kind: 'path',
                        attr: {
                            className: 'node-shape-filled node-shape-nostroke',
                            width: 56,
                            height: 56,
                            d: 'M48,0 L0,48 L8,56 L56,8 Z'
                        }
                    }
                ]
            }
        },
        package: {
            kind: 'container',
            attr: {
                shapes: [
                    {
                        kind: 'rect',
                        attr: {
                            width: 384,
                            height: 256
                        }
                    },
                    {
                        kind: 'rect',
                        attr: {
                            width: 128,
                            height: 64,
                            offset: {
                                x: -128,
                                y: -160
                            }
                        }
                    }
                ]
            }
        },
    };
});



// WEBPACK FOOTER //
// ./system/domain/entity/record-shape-pattern.js